import { Link, useLocation } from 'react-router-dom';
import type { VmsAdminConfigNavItem } from '../../constants/vmsAdminConfigNav';
import {
  VMS_ADMIN_CONFIG_NAV,
  isVmsAdminConfigNavItemActive,
} from '../../constants/vmsAdminConfigNav';

/** Section tabs for admin configuration pages (Annexure, Register, etc.). */
export function VmsAdminConfigSectionNav({
  onNavigate,
  className = '',
  items = VMS_ADMIN_CONFIG_NAV,
  ariaLabel = 'Admin configuration sections',
}: {
  onNavigate?: () => void;
  className?: string;
  items?: VmsAdminConfigNavItem[];
  ariaLabel?: string;
}) {
  const location = useLocation();

  return (
    <nav
      className={['vms-admin-config-section-nav', className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
    >
      {items.map((item) => {
        const active = isVmsAdminConfigNavItemActive(location.pathname, item);
        return (
          <Link
            key={item.href}
            to={item.href}
            className={[
              'vms-primary-nav__tab',
              active ? 'vms-primary-nav__tab--active' : 'vms-primary-nav__tab--inactive',
            ].join(' ')}
            onClick={onNavigate}
            aria-current={active ? 'page' : undefined}
          >
            {item.name}
          </Link>
        );
      })}
    </nav>
  );
}
